import { render, staticRenderFns } from "./PhotoGrid.vue?vue&type=template&id=ef878232&"
import script from "./PhotoGrid.vue?vue&type=script&lang=js&"
export * from "./PhotoGrid.vue?vue&type=script&lang=js&"
import style0 from "./PhotoGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports